import { default as indexMUmX8mAfjNMeta } from "/opt/build/repo/src/pages/index.vue?macro=true";
import { default as loginwV8UxyWAwuMeta } from "/opt/build/repo/src/pages/login.vue?macro=true";
import { default as storagepganH04MOqMeta } from "/opt/build/repo/src/pages/storage.vue?macro=true";
export default [
  {
    name: indexMUmX8mAfjNMeta?.name ?? "index",
    path: indexMUmX8mAfjNMeta?.path ?? "/",
    children: [],
    meta: indexMUmX8mAfjNMeta || {},
    alias: indexMUmX8mAfjNMeta?.alias || [],
    redirect: indexMUmX8mAfjNMeta?.redirect || undefined,
    component: () => import("/opt/build/repo/src/pages/index.vue").then(m => m.default || m)
  },
  {
    name: loginwV8UxyWAwuMeta?.name ?? "login",
    path: loginwV8UxyWAwuMeta?.path ?? "/login",
    children: [],
    meta: loginwV8UxyWAwuMeta || {},
    alias: loginwV8UxyWAwuMeta?.alias || [],
    redirect: loginwV8UxyWAwuMeta?.redirect || undefined,
    component: () => import("/opt/build/repo/src/pages/login.vue").then(m => m.default || m)
  },
  {
    name: storagepganH04MOqMeta?.name ?? "storage",
    path: storagepganH04MOqMeta?.path ?? "/storage",
    children: [],
    meta: storagepganH04MOqMeta || {},
    alias: storagepganH04MOqMeta?.alias || [],
    redirect: storagepganH04MOqMeta?.redirect || undefined,
    component: () => import("/opt/build/repo/src/pages/storage.vue").then(m => m.default || m)
  }
]